import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const fieldError: ThemeUICSSObject = {
  color: 'danger',
  mb: '0',
  pt: '2',
};

export default fieldError;
